import EvalCard from './src/main';

/* istanbul ignore next */
EvalCard.install = function(Vue) {
  Vue.component(EvalCard.name, EvalCard);
};

export default EvalCard;
